import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { VPopover } from 'v-tooltip';

const DEFAULT_POPOVER_SETTINGS = {
  'popover-class': [],
  'popover-base-class': ['pendo-popover'],
  'popover-wrapper-class': ['pendo-popover__wrapper'],
  'popover-inner-class': ['pendo-popover__inner'],
  'popover-arrow-class': ['pendo-popover__arrow'],
  'popper-options': {},
  'auto-height': true,
  'handle-resize': true,
  'placement': 'right',
  'trigger': 'hover',
  'delay': 0,
  'offset': 8
};
var script = {
  name: 'PendoPopover',
  components: {
    VPopover
  },
  inheritAttrs: false,
  props: {
    theme: {
      type: String,
      default: 'light',
      validator: theme => ['light', 'dark'].includes(theme)
    },
    arrow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    popoverAttrs() {
      const popoverProps = _objectSpread2({}, this.$attrs);
      Object.keys(DEFAULT_POPOVER_SETTINGS).forEach(prop => {
        if (!popoverProps[prop]) {
          popoverProps[prop] = DEFAULT_POPOVER_SETTINGS[prop];
        } else {
          popoverProps[prop] = Array.isArray(DEFAULT_POPOVER_SETTINGS[prop]) ? [...DEFAULT_POPOVER_SETTINGS[prop], popoverProps[prop]] : popoverProps[prop];
        }
      });
      return popoverProps;
    }
  },
  created() {
    DEFAULT_POPOVER_SETTINGS['popover-class'] = [].concat(`pendo-popover--${this.theme}`, ...(this.arrow ? ['has-popover-arrow'] : []));
  }
};

export { script as default };
//# sourceMappingURL=pendo-popover.vue2.js.map
